import { createAction, props } from '@ngrx/store';

export const setSelectedUserId = createAction('[Users] Set Selected User Id', props<{ userId: string }>());
